export default {"src":"/_next/static/media/House.32543ccc.svg","height":34,"width":40,"blurWidth":0,"blurHeight":0};